import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import DirectionsIcon from "@material-ui/icons/Directions";
import { CircularProgress } from "@material-ui/core";
import { UserContext } from "../providers/UserProvider";
import { db, submitFlag } from "../services/firebase";
import {InlineTex} from 'react-tex';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  loader: {
    margin: theme.spacing(1),
  },
  root: {
    padding: "2px 4px",
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#f5f5f5",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

export default function Challenge({
  name,
  topic,
    topicName,
  statement,
  points,
  solved,
  onSuccess,
  onFail,
}) {
  const classes = useStyles();
  const user = useContext(UserContext).user;
  const [value, setValue] = useState("");
  const [waiting, setWaiting] = useState(false);
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const handleSubmit = (event, user, flag) => {
    event.preventDefault();
    let uuid = submitFlag(user, topic, name, flag);
    setValue("");
    setWaiting(true);
    let path = `users/${user.uid}/submissions`;
    db.collection(path)
      .doc(uuid)
      .onSnapshot((doc) => {
        if (doc && doc.exists) {
          setTimeout(() => {
            setWaiting(false);
          }, 150);
          if (doc.data().success) {
            onSuccess(name, topicName);
          } else {
            onFail(name, topicName);
          }
          db.collection(path).doc(uuid).delete();
          db.collection(path)
            .doc(uuid)
            .onSnapshot(() => {});
        }
      });
  };
  if (solved) {
    return (
      <Grid item xs={12}>
        <Paper
          className={classes.paper}
          style={{ textAlign: "left"}}
        >
          <Grid container spacing={3} justify={"space-between"}>
            <Grid item>
              <Typography component="div" variant="body1">
                {name} ({points} Points). <InlineTex texSeperator="$" texContent={statement}/>
              </Typography>
            </Grid>
            <Grid item>
              <Typography color="primary" variant={"body1"}>
                SOLVED
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );
  } else {
    return (
      <Grid item xs={12}>
        <Paper className={classes.paper} style={{ textAlign: "left" }}>
          <Typography variant="body1">
            {name} ({points} Points). <InlineTex texSeperator="$" texContent={statement}/>
          </Typography>
          {waiting ? (
            <CircularProgress className={classes.loader} />
          ) : (
            <Paper
              component="form"
              onSubmit={(event) => handleSubmit(event, user, value)}
              className={classes.root}
            >
              <InputBase
                className={classes.input}
                placeholder="Enter your answer"
                inputProps={{ "aria-label": "flag" }}
                onChange={handleChange}
                value={value}
              />
              <IconButton
                color="primary"
                type="submit"
                className={classes.iconButton}
                aria-label="directions"
              >
                <DirectionsIcon />
              </IconButton>
            </Paper>
          )}
        </Paper>
      </Grid>
    );
  }
}
